var map = {
	"./alert_partner_gold_x1_new.png": 580,
	"./alert_partner_platinum_x1_new.png": 581,
	"./alert_partner_silver_x1_new.png": 582,
	"./alert_partner_white_x1_new.png": 583
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 388;